import { getter, commit, dispatch, watch } from './store'
import toasted from './toasted'
import BaseUtils from './base'
import Api from './api'

class Oauth extends BaseUtils {
  hasRole(role) {
    let hasRole = false
    const authorities = getter('oauth/grantedAuthorities')
    if (authorities) {
      var splitArray = role.split(',')
      if (splitArray.length > 1) {
        splitArray.forEach(function (elt) {
          if (hasRole == false && authorities.includes(elt)) {
            hasRole = true
          }
        })
      } else {
        hasRole = authorities.includes(role)
      }
    } else {
      hasRole = false
    }
    return hasRole
  }

  dmcAccepte() {
    return getter('oauth/dmcAccepte')
  }

  correspondantEtablissement() {
    return getter('oauth/correspondantEtablissement')
  }

  correspondantEntreprise() {
    return getter('oauth/correspondantEntreprise')
  }

  correspondantGroupement() {
    return getter('oauth/correspondantGroupement')
  }

  userid() {
    return getter('oauth/userid')
  }

  accessToken() {
    return getter('oauth/access_token')
  }

  username() {
    return getter('oauth/username')
  }

  nomComplet() {
    return getter('oauth/nomComplet')
  }

  idTechnique() {
    return getter('oauth/idTechnique')
  }

  tel() {
    return getter('oauth/tel')
  }

  logged() {
    return getter('oauth/logged') && getter('confirmauthentification/enCours')
  }

  loggedWithoutCheckConfirmAuth() {
    return getter('oauth/logged')
  }

  loggedAndConfirm() {
    return getter('oauth/confirmauth') && this.logged()
  }

  expired() {
    return getter('oauth/expired')()
  }

  loggedButExpired() {
    return this.logged() && this.expired()
  }

  userActif() {
    return getter('oauth/userActif')
  }

  userSalarie() {
    return getter('oauth/userSalarie')
  }

  login(login, password, roleCorrespondant, notif = true) {
    commit('loader/work', 1)
    const params = new URLSearchParams()
    params.append('grant_type', 'password')
    params.append('username', login + ':' + roleCorrespondant)
    params.append('password', password)
    return this.vue()
      .$http.post('/oauth/token', params, {
        headers: {
          Authorization: 'Basic ' + btoa('extraciem:Rg=Gd[)5Djv4Y-C-'),
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((responseToken) => {
        commit('loader/work', -1)
        commit('oauth/token', responseToken.body)

        const token = responseToken.body

        const extraInfoAuhthentification = {
          roleCorrespondant: roleCorrespondant,
        }

        return this.vue()
          .$http.post('/oauth/principal', extraInfoAuhthentification, {
            headers: { Authorization: 'Bearer ' + token.access_token },
          })
          .then((response) => {
            if (response.body && response.body.anglaisUniquement == true) {
              this.vue().$i18n.locale = 'en_EN'
            }
            if (notif) {
              toasted.info('auth.connected')
            }
            commit('oauth/user', response.body)
          })
      })
      .catch((response) => {
        if (response.status === 400) {
          if (response.body.error_description === 'user.locked') {
            toasted.error('user.locked')
          } else if (
            response.body.error_description &&
            response.body.error_description.startsWith('tentative')
          ) {
            toasted.error('login.' + response.body.error_description)
          } else if (response.body.error === 'invalid_grant') {
            toasted.error('login.invalid_grant')
          } else {
            toasted.error('auth.unauthorized')
          }
        } else if (response.status === 403) {
          toasted.error(response.body.error_description)
        } else {
          toasted.error('auth.unauthorized')
        }
      })
      .finally(() => commit('loader/work', -1))
  }

  requireLogin(to) {
    dispatch('oauth/loginAndRedirect', to)
  }

  refreshToken() {
    const refreshToken = getter('oauth/refresh_token')
    const params = new URLSearchParams()
    params.append('grant_type', 'refresh_token')
    params.append('refresh_token', refreshToken)
    return this.vue()
      .$http.post('/oauth/token', params, {
        headers: {
          Authorization: 'Basic ' + btoa('extraciem:Rg=Gd[)5Djv4Y-C-'),
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => commit('oauth/token', response.body))
      .catch(() => {
        this.logout()
      })
  }

  logout() {
    new Api('logout', 'oauth/')
      .post()
      .then(() => {
        toasted.info('auth.revoked')
      })
      .catch(() => {
        //
      })
      .finally(() => {
        commit('confirmauthentification/enCours', false)
        toasted.info('auth.disconnected')
        commit('oauth/token', null)
        commit('oauth/user', null)
      })
  }

  renewAccessToken(promiseBuilder) {
    if (this.loggedButExpired()) {
      return this.refreshToken()
        .then(() => {})
        .then(promiseBuilder)
    } else {
      return promiseBuilder()
    }
  }

  whenLogged(promiseBuilder) {
    if (this.logged()) {
      this.renewAccessToken(() => promiseBuilder(true))
    }

    watch(() => getter('oauth/logged'), promiseBuilder)
  }
}

const instance = new Oauth()

// expore l'instance par défaut
export default instance
